import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconCity = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconCity",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M21.41 20.83h-.23v-5.67a.6.6 0 0 0-.32-.52l-2.02-1.01v-1.6a.6.6 0 0 0-.33-.51l-2.8-1.4v-5.2a.6.6 0 0 0-.59-.59h-.19V2.6a.6.6 0 0 0-.59-.59H9.66a.6.6 0 0 0-.59.59v1.75h-.2a.6.6 0 0 0-.58.59v2.23H5.75a.6.6 0 0 0-.59.58v8.6H3.41a.6.6 0 0 0-.59.58v3.9h-.23a.59.59 0 0 0 0 1.18H21.4a.59.59 0 1 0 0-1.17M10.24 3.17h3.52v1.17h-3.52zm-.78 2.35h5.08v4l-.72-.35a.6.6 0 0 0-.84.53v11.13h-1.96V7.74a.6.6 0 0 0-.58-.58h-.98zm-3.12 2.8h3.51v12.5H8.68v-3.9a.6.6 0 0 0-.59-.58H6.34zm0 12.5v-1.36a.59.59 0 0 0-1.18 0v1.37H4V17.5h3.52v3.32zm7.8-10.18 3.52 1.76v8.43h-3.51zm4.7 10.19v-5.89l1.17.59v5.3z"
  })
}));
IconCity.displayName = 'IconCity';